import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { BsBarChart, BsChatText } from 'react-icons/bs'
import { ChatUnreadBadge } from '../Badges'
import { NavLink, NavLinkType } from '../NavLink'

interface IProps {
  onLinkClick: () => void
}

export const GeneralLinks = ({ onLinkClick }: IProps) => {
  const { t } = useTranslation()

  const links: Array<NavLinkType> = [
    {
      path: '/dashboard',
      label: t('dashboard'),
      icon: BsBarChart,
    },
    {
      path: '/chats',
      label: t('chats'),
      icon: BsChatText,
      renderRightSection: ({ isActive }: { isActive: boolean }) => (
        <ChatUnreadBadge isActive={isActive} />
      ),
    },
  ]

  return (
    <>
      {links.map((item) => {
        return <NavLink key={item.path} onClick={onLinkClick} {...item} />
      })}
    </>
  )
}
